import React, { useEffect } from "react";
import "../style.css";
export const CustomSelect = ({
  values,
  optionHeading,
  selectedValue,
  handleChange,
  setSelectedValue
}) => {
  useEffect(()=>{
    return ()=>setSelectedValue('');
  },[])
  return (
    <div>
      <select
        value={selectedValue}
        onChange={handleChange}
        id="financialYear"
        className="select-financial-year"
        style={{
          width: "100%",
          fontSize: "14px",
          border: "1px solid #ccc",
          borderRadius: "4px",
          height: "2.15em",
          
        }}
      >
        <option value="" className="option-for-select">
          {optionHeading ? optionHeading : "Select"}
        </option>
        {values.map((item) => (
          <option className="option-for-select" key={item.label} value={item.value}>
            {item.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default CustomSelect;
